export class UUIDTime {
  static create () {
    // 生成一个随机数,防止在拖拽多列布局控件时同时生成多个rc-draggable的componentId重复问题
    let num = parseInt(Math.random() * 5001 + 1)
    num += Date.now()
    return num.toString(36)
  }
}



// WEBPACK FOOTER //
// ./src/plugins/uuid-time.js